import React, { useEffect, useState } from 'react';
import { InfoIcon } from 'lucide-react';
interface Option {
  text: string;
  points: number;
}
interface QuizQuestionProps {
  question: string;
  options: Option[];
  onAnswer: (points: number) => void;
  insight: string;
  source: string;
  questionNumber: number;
  totalQuestions: number;
}
export function QuizQuestion({
  question,
  options,
  onAnswer,
  insight,
  source,
  questionNumber,
  totalQuestions
}: QuizQuestionProps) {
  const [selectedOption, setSelectedOption] = useState<number | null>(null);
  const [showInsight, setShowInsight] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [hoverIndex, setHoverIndex] = useState<number | null>(null);
  // Reset state when question changes
  useEffect(() => {
    setSelectedOption(null);
    setShowInsight(false);
    setIsLoading(false);
  }, [question]);
  const handleOptionClick = (index: number) => {
    setSelectedOption(index);
    setShowInsight(true);
    setIsLoading(true);
    // Short delay to show insight before moving to next question
    setTimeout(() => {
      onAnswer(options[index].points);
      setShowInsight(false);
      setSelectedOption(null);
      setIsLoading(false);
    }, 2000);
  };
  return <div className="bg-white rounded-lg p-6 shadow-md border border-gray-100" data-id="element-200">
      <div className="mb-6" data-id="element-201">
        <h3 className="text-xl font-semibold mb-2" data-id="element-202">{question}</h3>
        <p className="text-gray-500 text-sm" data-id="element-203">
          Välj det alternativ som bäst beskriver din situation
        </p>
      </div>
      <div className="space-y-3 mb-6" data-id="element-204">
        {options.map((option, index) => <button key={index} onClick={() => handleOptionClick(index)} onMouseEnter={() => setHoverIndex(index)} onMouseLeave={() => setHoverIndex(null)} disabled={selectedOption !== null} className={`w-full text-left p-5 rounded-lg border-2 transition-all relative ${selectedOption === index ? 'bg-red-50 border-red-600 shadow-md' : hoverIndex === index ? 'bg-gray-50 border-gray-300 shadow-sm' : 'bg-white border-gray-200 hover:border-gray-300'}`} type="button" data-id="element-205">
            <div className="flex items-center" data-id="element-206">
              <div className={`w-5 h-5 rounded-full border-2 mr-3 flex-shrink-0 flex items-center justify-center ${selectedOption === index ? 'border-red-600 bg-red-600' : 'border-gray-300'}`} data-id="element-207">
                {selectedOption === index && <svg className="w-3 h-3 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-208">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="3" d="M5 13l4 4L19 7" data-id="element-209" />
                  </svg>}
              </div>
              <span className={selectedOption === index ? 'font-medium' : ''} data-id="element-210">
                {option.text}
              </span>
            </div>
          </button>)}
      </div>
      {showInsight && <div className="bg-blue-50 p-4 rounded-lg border border-blue-200 mt-4 animate-fade-in" data-id="element-211">
          <div className="flex items-start" data-id="element-212">
            <InfoIcon className="h-5 w-5 text-blue-500 mr-2 flex-shrink-0 mt-0.5" data-id="element-213" />
            <div data-id="element-214">
              <p className="text-sm font-medium text-blue-800 mb-1" data-id="element-215">
                Visste du att...
              </p>
              <p className="mb-1 text-blue-800" data-id="element-216">{insight}</p>
              <p className="text-xs text-blue-600" data-id="element-217">{source}</p>
            </div>
          </div>
        </div>}
      {isLoading && <div className="flex justify-center items-center mt-6" data-id="element-218">
          <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-red-600" data-id="element-219"></div>
          <span className="ml-2 text-sm text-gray-600" data-id="element-220">
            Går vidare till nästa fråga...
          </span>
        </div>}
    </div>;
}